import { render, staticRenderFns } from "../../../pages/physician/management/management.html?vue&type=template&id=17cde954&scoped=true&"
import script from "../../../pages/physician/management/management.js?vue&type=script&lang=js&"
export * from "../../../pages/physician/management/management.js?vue&type=script&lang=js&"
import style0 from "../../../pages/physician/management/management.css?vue&type=style&index=0&id=17cde954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cde954",
  null
  
)

export default component.exports